export const getLoading = ({ state }) => state.AppReducer.loading;

export const getRedeeming = ({ state }) => state.AppReducer.isRedeem;